import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

const Product = (props) => {
  return (
    <a href={props.link} className='product'>
      <div className='img-product'>
        <LazyLoadImage
          effect='blur'
          src={props.img}
          alt={props.name}
          width='100px'
          height='100px'
          placeholderSrc={'/images/logo.png'}
        />
      </div>
      <div className='name'>{props.name}</div>
      <div className='caption'>{props.caption}</div>
      <div className='price'>
        <span className='amount'>{props.price}</span>
        <span>تومان</span>
      </div>
    </a>
  )
}
export default Product
